/**
 * Resolve the application's initial language from the browser, matching the
 * logic used in AppComponent. Centralised so LOCALE_ID (date/number formatting)
 * and the initial PrimeNG translation agree with ngx-translate on first paint.
 */
export type AppLang = 'es' | 'en';

export function getInitialLang(): AppLang {
  if (typeof navigator === 'undefined') return 'en';
  return navigator.language?.startsWith('es') ? 'es' : 'en';
}

/** Map an app language to the Angular LOCALE_ID used for DatePipe/DecimalPipe. */
export function localeIdFor(lang: AppLang): string {
  return lang === 'es' ? 'es-ES' : 'en-US';
}
